import httpAdmin from '@/httpCommon/axiosClient';

class StaffService {
    getAll = async (params?: any) => {
        const res = await httpAdmin.get('/staff', { params });
        return res?.data;
    };

    getAllWithDeleted = async (params?: any) => {
        const res = await httpAdmin.get('/staff/findAllWithDeleted', { params });
        return res?.data;
    };

    delete = async (id: string | number) => {
        const res = await httpAdmin.delete(`/staff/${id}`);
        return res?.data;
    };

    create = async (body: any) => {
        const res = await httpAdmin.post('/staff', body);
        return res?.data;
    };

    update = async (id: string | number, body: any) => {
        const res = await httpAdmin.patch(`/staff/${id}`, body);
        return res?.data;
    };

    detail = async (id: string) => {
        const res = await httpAdmin.get(`/staff/${id}`);
        return res?.data;
    };

    deleteMany = async (body: any) => {
        const res = await httpAdmin.patch(`/staff/delete`, body);
        return res?.data;
    };

    downloadCSV = async (params: any) => {
        const res = await httpAdmin.get('/staff/download-csv', { params });
        return res?.data;
    };
}
export default new StaffService();
